import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const ErrorToast = ({ open, onClose, message }) => {
    return (
        <Snackbar open={open} autoHideDuration={8000} onClose={onClose}>
            <Alert
                severity="error"
                sx={{
                    width: '100%',
                    backgroundColor: '#C62828',
                    color: '#FFFFFF',
                    '& .MuiAlert-icon': {
                        color: '#FFFFFF'
                    }
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default ErrorToast;